import { Divider, Select } from '@nike/eds';
import { addMonths } from 'date-fns';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { DateRange as DateRangeSelect } from 'react-date-range';

import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import { MOMENT_DATE_FORMAT, NPOS } from '../../../../../utils/constants';
import './daterange-picker.css';
import { getPurchaseDateFilterTestId } from '../../../../../utils/testUtils';

import { getDateStyles, populateTimeRange } from './dateUtils';

const DateRangePicker = ({
  ranges,
  dateRangePickerOnChange,
  timeOnChange,
  timeRange,
  timezone,
  translations
}) => {
  const dateRenderer = (date) => {
    const { startDate, endDate } = ranges?.[0];
    const { textColorStyle, dateStyle } = getDateStyles(
      date,
      startDate,
      endDate,
      timezone,
      moment
    );

    const dateTestId = getPurchaseDateFilterTestId(moment(date));

    return (
      <div className="date" style={dateStyle}>
        <span data-testid={dateTestId} style={{ color: textColorStyle, fontSize: '16px' }}>
          {moment(date).date()}
        </span>
      </div>
    );
  };

  return (
    <div
      className="d-sm-flx flx-dir-sm-r"
      style={{ gap: '20px', minWidth: 'max-content' }}
    >
      <div>
        <DateRangeSelect
          fixedHeight
          dayContentRenderer={dateRenderer}
          direction="horizontal"
          dragSelectionEnabled={false}
          maxDate={new Date(moment.tz(timezone).format(MOMENT_DATE_FORMAT))}
          monthDisplayFormat="LLLL yyyy"
          months={2}
          moveRangeOnFirstSelection={false}
          ranges={ranges}
          showDateDisplay={false}
          showMonthAndYearPickers={false}
          showSelectionPreview={false}
          shownDate={addMonths(new Date(), -1)}
          onChange={(item) => dateRangePickerOnChange(item)}
        />
      </div>

      <Divider className="eds-border--disabled" orientation="vertical" style={{ height: 'auto', width: '1px' }} />

      <div
        className="d-sm-flx flx-dir-sm-c flx-jc-sm-c "
        style={{ gap: '20px', minWidth: 'fit-content' }}
      >
        <div className="d-sm-flx flx-dir-sm-c flx-ai-sm-fs">
          <p className="eds-type--subtitle-1" htmlFor="from-time-dropdown">
            {translations.RL_FromDate}
          </p>
          <Select
            data-testid="from-time-dropdown"
            defaultValue={NPOS.DAY_START_TIME}
            id="from-time-dropdown"
            isSearchable={false}
            options={populateTimeRange(false, moment)}
            value={timeRange.from}
            onChange={(val) => timeOnChange(val, 'from')}
          />
        </div>
        <div className="d-sm-flx flx-dir-sm-c flx-ai-sm-fs">
          <p className="eds-type--subtitle-1" htmlFor="from-time-dropdown">
            {translations.RL_ToDate}
          </p>
          <Select
            data-testid="to-time-dropdown"
            defaultValue={NPOS.DAY_END_TIME}
            id="to-time-dropdown"
            isSearchable={false}
            options={populateTimeRange(true, moment)}
            value={timeRange.to}
            onChange={(val) => timeOnChange(val, 'to')}
          />
        </div>
      </div>
    </div>
  );
};

DateRangePicker.defaultProps = {
  timezone: '',
};

DateRangePicker.propTypes = {
  dateRangePickerOnChange: PropTypes.func.isRequired,
  ranges: PropTypes.arrayOf(PropTypes.shape).isRequired,
  timeOnChange: PropTypes.func.isRequired,
  timeRange: PropTypes.shape().isRequired,
  timezone: PropTypes.string,
  translations: PropTypes.shape().isRequired,
};

export default DateRangePicker;
